//  Modern Sidebar Komponenti
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, FolderOpen, Zap, Clock, Globe, Send, Settings, HelpCircle, X } from 'lucide-react';

const Sidebar = ({ isOpen, onClose }) => {
  const location = useLocation();

  const menuItems = [
    {
      name: 'Gösterge Paneli',
      path: '/dashboard',
      icon: LayoutDashboard
    },
    {
      name: 'Koleksiyonlar',
      path: '/collections',
      icon: FolderOpen
    },
    {
      name: 'Uç Noktalar',
      path: '/endpoints',
      icon: Zap
    },
    // API Test Aracı, Geçmiş, Ortam kaldırıldı
  ];

  const secondaryItems = [
    {
      name: 'Ayarlar',
      path: '/settings',
      icon: Settings
    },
    {
      name: 'Yardım',
      path: '/help',
      icon: HelpCircle
    }
  ];

  const isActiveRoute = (path) => {
    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };

  return (
    <>
      {/*  Overlay for mobile */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden animate-fade-in"
          onClick={onClose}
        />
      )}

      {/*  Sidebar */}
      <aside className={`fixed inset-y-0 left-0 z-50 w-64 bg-secondary border-r border-primary transform transition-transform duration-300 ease-out lg:relative lg:translate-x-0 ${
        isOpen ? 'translate-x-0' : '-translate-x-full'
      }`}>
        <div className="flex flex-col h-full">
          {/*  Logo Header - Minimal, sade */}
          <div className="flex items-center justify-between h-16 px-5 border-b border-primary">
            <Link to="/dashboard" className="flex items-center gap-2.5 group">
              <div className="w-8 h-8 flex items-center justify-center">
                <img
                  src="/logo.png"
                  alt="Tegim"
                  className="w-full h-full object-contain"
                />
              </div>
              <h1 className="text-lg font-semibold" style={{ color: 'var(--text-primary)' }}>
                Tegim
              </h1>
            </Link>

            {/*  Close button for mobile */}
            <button
              onClick={onClose}
              className="p-1.5 hover:bg-hover rounded transition-all lg:hidden"
            >
              <X className="w-5 h-5" style={{ color: 'var(--text-secondary)' }} />
            </button>
          </div>

          {/*  Navigation - Minimal kurumsal */}
          <nav className="flex-1 px-3 py-4 overflow-y-auto custom-scrollbar">
            {/*  Main Menu */}
            <div className="space-y-0.5 mb-6">
              {menuItems.map((item) => {
                const Icon = item.icon;
                const isActive = isActiveRoute(item.path);

                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    onClick={() => onClose()}
                    className={`group flex items-center gap-2.5 px-3 py-2.5 rounded text-sm font-medium transition-all relative ${
                      isActive
                        ? 'bg-[var(--accent-light)] text-[var(--accent)] border border-[var(--accent-light)]'
                        : 'hover:bg-hover'
                    }`}
                    style={!isActive ? { color: 'var(--text-secondary)' } : {}}
                  >
                    {isActive && (
                      <div className="absolute left-0 top-1/2 -translate-y-1/2 w-0.5 h-6 bg-[var(--accent)]" />
                    )}
                    <Icon className="w-4 h-4 flex-shrink-0" />
                    <span>{item.name}</span>
                  </Link>
                );
              })}
            </div>

            {/*  Divider */}
            <div className="h-px bg-secondary my-4" />

            {/*  Secondary Menu */}
            <div className="space-y-0.5">
              {secondaryItems.map((item) => {
                const Icon = item.icon;
                const isActive = isActiveRoute(item.path);

                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    onClick={() => onClose()}
                    className={`group flex items-center gap-2.5 px-3 py-2.5 rounded text-sm font-medium transition-all relative ${
                      isActive
                        ? 'bg-[var(--accent-light)] text-[var(--accent)] border border-[var(--accent-light)]'
                        : 'hover:bg-hover'
                    }`}
                    style={{ color: isActive ? 'var(--accent)' : 'var(--text-tertiary)' }}
                  >
                    {isActive && (
                      <div className="absolute left-0 top-1/2 -translate-y-1/2 w-0.5 h-6 bg-[var(--accent)]" />
                    )}
                    <Icon className="w-4 h-4 flex-shrink-0" />
                    <span>{item.name}</span>
                  </Link>
                );
              })}
            </div>
          </nav>

          {/*  API Status Footer - Minimal */}
          <div className="p-3 border-t border-primary">
            <div className="flex items-center gap-2 px-3 py-2 bg-success-light rounded">
              <div className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-success opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-success"></span>
              </div>
              <span className="text-xs font-medium text-success">
                API Çevrimiçi
              </span>
            </div>
          </div>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
